<div class="row form-group">
  <div class="col-4 mt-3">
    <button [disabled]="disabled()" #adicionar_ (click)="adicionar()" data-toggle="modal" data-target="#dialogExecutora"
      class="btn btn-sm btn-outline-primary" title="CTRL + I">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-eddy-sm" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col" style="width: 30%;">Motivo</th>
      <th scope="col" style="width: 15%;">Início</th>
      <th scope="col" style="width: 15%;">Vencimento</th>
      <th scope="col" style="width: 5%;" class="text-center">Bloq. Contratação</th>
      <th scope="col" style="width: 5%;" class="text-center">Bloq. Compra</th>
      <th scope="col" style="width: 5%;" class="text-center">Bloq. Empenho</th>
      <th scope="col" style="width: 5%;" class="text-center">Bloq. Pagamento</th>
      <th scope="col" style="width: 10%;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel">{{item.motivo}}</td>
      <td *ngIf="!item.editavel">{{item.data_inicio | date:'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.data_vencimento | date:'dd/MM/yyyy':'GMT'}}</td>

      <td *ngIf="!item.editavel" class="text-center">
        <i *ngIf="item.bloquear_contratacao" class="fa fa-check text-success"></i>
        <i *ngIf="!item.bloquear_contratacao" class="fa fa-close text-danger"></i>
      </td>
      <td *ngIf="!item.editavel" class="text-center">
        <i *ngIf="item.bloquear_compra" class="fa fa-check text-success"></i>
        <i *ngIf="!item.bloquear_compra" class="fa fa-close text-danger"></i>
      </td>
      <td *ngIf="!item.editavel" class="text-center">
        <i *ngIf="item.bloquear_empenho" class="fa fa-check text-success"></i>
        <i *ngIf="!item.bloquear_empenho" class="fa fa-close text-danger"></i>
      </td>
      <td *ngIf="!item.editavel" class="text-center">
        <i *ngIf="item.bloquear_pagamento" class="fa fa-check text-success"></i>
        <i *ngIf="!item.bloquear_pagamento" class="fa fa-close text-danger"></i>
      </td>

      <td *ngIf="item.editavel">
        <input #motivo_ [(ngModel)]="item.motivo" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="motivo">
      </td>
      <td *ngIf="item.editavel">
        <p-calendar id="data_inicio" [(ngModel)]="item.data_inicio" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel">
        <p-calendar id="data_vencto" [(ngModel)]="item.data_vencimento" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <p-checkbox [(ngModel)]="item.bloquear_contratacao" [binary]="true"></p-checkbox>
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <p-checkbox [(ngModel)]="item.bloquear_compra" [binary]="true"></p-checkbox>
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <p-checkbox [(ngModel)]="item.bloquear_empenho" [binary]="true"></p-checkbox>
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <p-checkbox [(ngModel)]="item.bloquear_pagamento" [binary]="true"></p-checkbox>
      </td>
      <td class="text-right">
        <button [disabled]="disabled()" *ngIf="!item.editavel" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button [disabled]="disabled()" *ngIf="!item.editavel" (click)="remover(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>